/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Client_Status_LabelInputs */

const en_client_status_label = /** @type {(inputs: Client_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "lead") return /** @type {LocalizedString} */ (`Lead`);
	if (i?.status === "active") return /** @type {LocalizedString} */ (`Active`);
	if (i?.status === "in_negotiation") return /** @type {LocalizedString} */ (`In negotiation`);
	if (i?.status === "expired") return /** @type {LocalizedString} */ (`Expired`);
	if (i?.status === "archived") return /** @type {LocalizedString} */ (`Archived`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

const pt_br2_client_status_label = /** @type {(inputs: Client_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "lead") return /** @type {LocalizedString} */ (`Lead`);
	if (i?.status === "active") return /** @type {LocalizedString} */ (`Ativo`);
	if (i?.status === "in_negotiation") return /** @type {LocalizedString} */ (`Em negociação`);
	if (i?.status === "expired") return /** @type {LocalizedString} */ (`Vencido`);
	if (i?.status === "archived") return /** @type {LocalizedString} */ (`Arquivado`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

/**
* | status | output |
* | --- | --- |
* | "lead" | "Lead" |
* | "active" | "Active" |
* | "in_negotiation" | "In negotiation" |
* | "expired" | "Expired" |
* | "archived" | "Archived" |
* | * | "{status}" |
*
* @param {Client_Status_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const client_status_label = /** @type {((inputs: Client_Status_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Status_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_status_label(inputs)
	return pt_br2_client_status_label(inputs)
});